module.exports = __webpack_public_path__ + "static/media/ConnectID_Primary_Symbol.1f6898ec.png";